
import { changePage, logOutMode } from "../../Redux/slices/globalSlice";
import { changeToLogin, changeToLogout } from "../../Redux/slices/userSlice";
import { removeLocalStorage } from "./Token";

export const HandleLogin = (navigate) => {
    return async (dispatch) => {
        try {
            dispatch(changePage(0));
            dispatch(changeToLogin());
            navigate('/dashboard');
        } catch (e) {}
    }
}

export const HandleLogOut = () => {
    return async (dispatch) => {
        try {
            removeLocalStorage();
            dispatch(logOutMode());
            dispatch(changeToLogout());
        } catch (e) {}
    }
}